<script lang="ts">
    
    import { getContext, onDestroy, onMount, SvelteComponent } from "svelte";
    import { fade } from "svelte/transition";
    import GameClock from "../../Components/Game/GameClock.svelte";
    import GameHistoric from "../../Components/Game/GameHistoric.svelte";
    import GameMexHistoric from "../../Components/Game/GameMexHistoric.svelte";
    import GameNumbersIndicator from "../../Components/Game/GameNumbersIndicator.svelte";
    import PlayersRanking from "../../Components/Game/PlayersRanking.svelte";
    import Win from "../../Components/Game/Win.svelte";
    import MessagesMarquee from "../../Components/Messages/MessagesMarquee.svelte";
    import AwardTitle from "../../Components/Monitor/AwardTitle.svelte";
    import Bingo75NumbersGrid from "../../Components/Monitor/Bingo75NumbersGrid.svelte";
    import BingoMexNumbersGrid from "../../Components/Monitor/BingoMexNumbersGrid.svelte";
    import Confetti from "../../Components/Monitor/Confetti.svelte";
    import NumbersGrid from "../../Components/Monitor/NumbersGrid.svelte";
    import PlayerDisplay from "../../Components/Monitor/PlayerDisplay.svelte";
    import RoomQr from "../../Components/Rooms/RoomQr.svelte";
    import FigureName from "../../Components/Shared/FigureName.svelte";
    import If from "../../Components/Shared/If.svelte";
    import Watch from "../../Components/Watch.svelte";
    import type { RealTimeEvent, FigureName as FigureNameType, GameType, Fn } from "../../global";
    import type { Game } from "../../Model/Game";
    import type { Player } from "../../Model/Player";
    import type { Room } from "../../Model/Room";
    import { authorizationService, gamesService, playersFactory, realTimeService, roomsService, GameTypeService } from "../../Services";
    import type { EventsChannel } from "../../Services/EventsChannel";
    import { i18n } from "../../Services/i18n";
    import { reload } from "../../Services/ReloadService";
    import { Alert, FormGroup, Icon, Label, Modal, ModalBody, ModalHeader } from "sveltestrap";
    import { State } from "../../Model/State";
    import Button from "../../Components/Manager/Button.svelte";
    import Menu from "../../Components/Manager/Menu.svelte";
    import { navigate } from "svelte-navigator";
    import RightMenuBtn from "./RightMenuBtn.svelte";
    import BingoMusicNumbersGrid from "../../Components/Monitor/BingoMusicNumbersGrid.svelte";
    import GameMusicHistoric from "../../Components/Game/GameMusicHistoric.svelte";

    type FigureNotice = {
        figureName: FigureNameType;
        player: Player;
    };

    export let room: Room;

    let reloading = false;

    $: reload.subscribe(value => reloading = value);
    const roomEvents = room.getEventsChannel();
    const figureScreentSeconds = 30;
    const rankingSize = 5;
    // const players = new PlayersCollection();
    // Mapeo de nombres de componentes a componentes reales
    const componentMap = {
        'GameHistoric': GameHistoric,
        'GameMexHistoric': GameMexHistoric,
        'GameMusicHistoric': GameMusicHistoric,
        'NumbersGrid': NumbersGrid,
        'Bingo75NumbersGrid': Bingo75NumbersGrid,
        'BingoMexNumbersGrid': BingoMexNumbersGrid,
        'BingoMusicNumbersGrid': BingoMusicNumbersGrid
    };

    let game: Game;
    let gameEvents: EventsChannel;
    let winner: Player;
    let setIdleTimeout: number;
    let figureNotice: FigureNotice;
    let windowInnerWidth = 1000;
    let showQr: State<boolean>;
    let reloadInterval: ReturnType<typeof setInterval>;

    let errorCode = null;

    // Usar GameTypeService para obtener el límite de números
    $: numbersLimit = game ? GameTypeService.getMaxNumbers(game.type) : 0;

    
    let candidateNumbers = [];
    let nextBtnDisabled = false;
    let isCooldown = false;
    const cooldownTime = 3000;

    const clearGame: () => void = getContext('clearGame');
    const toggleRoomSettingsModal: Fn = getContext('toggleRoomSettingsModal');
    let openRightMenu = false;
    let showCancelOptions: boolean = false;
    let openEndGameModal: boolean = false;
    let cancelMotive = null;

    let actualNumber;

    onMount(mount);
    onDestroy(() => {
        roomEvents.destroy();
        gameEvents?.destroy();
        window.clearTimeout(setIdleTimeout);
        clearInterval(reloadInterval);
    });

    async function mount(): Promise<void> {
        try {
            game = await roomsService.getCurrentGameAtRoom(room.id);
            gameEvents = game.getEventsChannel();
            roomEvents.on('game_cancel', onGameCancel);
            roomEvents.on('game_created', onGameCreated);
            // roomEvents.on('player_enter', onPlayerEnter);
            // roomEvents.on('player_leave', onPlayerLeave);
            // roomEvents.on('identity_override', onIdentityOverride);
            roomEvents.on('set_idle', onSetIdle);
            roomEvents.on('updated', onUpdated);
            gameEvents.on('add_number', onAddNumber);
            gameEvents.on('figure', onFigure);
            gameEvents.on('bingo', onBingo);
            gameEvents.on('finalize', onFinalize);
            // players.add(...await roomsService.getPlayersInRoom(room.id));

            if(room.showRoomQrInMonitor.value && !game.playWithPaper) {
                showQr = new State(true);
            } else if(room.showRoomQrInMonitor.value && game.playWithPaper) {
                showQr = new State(false);
            } else if(!room.showRoomQrInMonitor.value && !game.playWithPaper) {
                showQr = new State(false);
            }

            errorCode = null;

            numbersLimit = getGameNumbersLimit();
            numbersLimit = numbersLimit;

            candidateNumbers = createCandidateNumbers();
            candidateNumbers = candidateNumbers;

            nextBtnDisabled = game?.numbers.value.length === numbersLimit;
            nextBtnDisabled = nextBtnDisabled;

        } catch (error) {
            console.log(error);
            errorCode = 'e-2003';
        }
    }

    function onUpdated() {
        location.reload();
    }

    function destroy(): void {
        roomEvents.destroy();
        gameEvents?.destroy();
        window.clearTimeout(setIdleTimeout);
    }

    function onGameCancel(): void {
        room.state.set('idle');
    }

    function onAddNumber({ data }: RealTimeEvent): void {
        /* game.addNumber(data.number); */
        data.game_numbers.map(number => {
            if(!game.hasNumber(number)) {
                game.addNumber(number);
            }
            /* Actualizamos la variable sin recargar la web */
            if(candidateNumbers.includes(number)) {
                const index = candidateNumbers.indexOf(number);
                candidateNumbers.splice(index, 1);
                candidateNumbers = candidateNumbers;
            }
        })
    }

    // function onPlayerEnter({ data }: RealTimeEvent): void {
    //     if (players.has(data.player.id)) {
    //         return;
    //     }
    //     players.add(playersFactory.createPlayerFromDto(data.player));
    // }

    // function onPlayerLeave({ data }: RealTimeEvent): void {
    //     players.delete(data.player.id);
    // }

    function onFigure({ data }: RealTimeEvent): void {
        figureNotice = {
            figureName: data.figure.name,
            player: playersFactory.createPlayerFromDto(data.player),
        };
        setTimeout(() => figureNotice = undefined, figureScreentSeconds * 1000);
    }

    function onBingo({ data }: RealTimeEvent): void {
        figureNotice = undefined;
        winner = playersFactory.createPlayerFromDto(data.player);

         // Iniciar recarga de la página cada 15 segundos cuando winner es true
        clearInterval(reloadInterval);
        reloadInterval = setInterval(() => {
            location.reload();
        }, 20000);
    }

    function onGameCreated(): void {
        window.clearTimeout(setIdleTimeout);
        room.state.set('waiting');
    }

    function onFinalize(): void {
        winner = undefined;
    }

    function onSetIdle(): void {
        room.state.set('idle');
    }

    // function onIdentityOverride({ data }: RealTimeEvent): void {
    //     if (!players.has(data.player.id)) {
    //         return;
    //     }
    //     const player = players.get(data.player.id)!;
    //     player.identityOverride.set(true);
    //     player.name.set(data.player.name);
    //     player.pictureId.set(data.player.pictureId);
    // }

    function createCandidateNumbers(): number[] {
        const numbers: number[] = [];
        for (let n = 1; n <= numbersLimit; n++) {
            if (!game.hasNumber(n)) {
                numbers.push(n);
            }
        }
        return numbers;
    }

    function getGameNumbersLimit() {
        if(!game) {
            return;
        }

        return GameTypeService.getMaxNumbers(game.type);
    }

    function nextNumber(): void {
        if (nextBtnDisabled) {
            return;
        }
        disableNext();
        const index = Math.floor(candidateNumbers.length * Math.random());
        const [number] = candidateNumbers.splice(index, 1);
        actualNumber = number;
        game.addNumber(number);
        realTimeService.send('game_add_number', {
            gameId: game.id,
            number,
            numbers: game.numbers.value
        });
    }

    function disableNext(): void {
        nextBtnDisabled = game.numbers.value.length === numbersLimit;

        if (nextBtnDisabled) {
            //hemos alcanzado el límite de números para este juego
            return;
        }

        nextBtnDisabled = true;
        isCooldown = true;
        setTimeout(() => {
            nextBtnDisabled = false;
            isCooldown = false;
        }, cooldownTime);
    }

    function toggleEndGameOptions(): void {
        showCancelOptions = !showCancelOptions;
        cancelMotive = null;
    }

    function toggleEndGameModal(): void {
        openEndGameModal = !openEndGameModal;
        cancelMotive = null;
    }

    async function endGame(motive: string): Promise<boolean> {
        if (!confirm($i18n("¿Seguro que desea cancelar el juego actual?"))) {
            return false;
        }
        try {
            openRightMenu = false
            cancelMotive = motive
            await gamesService.cancelGame(game.id, cancelMotive);
            realTimeService.send('set_idle', { roomId: game.roomId });
            clearGame();
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    function toggleRightMenu(): void {
        openRightMenu = !openRightMenu;
    }

    async function onLogout(): Promise<void> {
        if (await endGame('logout')) {
            authorizationService.clearToken();
            navigate('/');
        }
    }

    async function toggleQr() {
        room.showRoomQrInMonitor.set(!room.showRoomQrInMonitor.value);
        await roomsService.saveRoom(room);
    }


</script>

<svelte:window bind:innerWidth={windowInnerWidth} />

<div class="monitor-view ">
    <div class="historic">
        <div class="game-logo">
            <img src="/images/game-name.png" alt="">
        </div>
        <div class="game-historic notranslate">
            {#if game}
                <Watch state={game.numbers} let:value={numbers}>
                    <div class='d-flex flex-column h-100'>
                        {#if numbers.length > 0}
                            <svelte:component this={componentMap[GameTypeService.getHistoricComponentName(game.type)]} {game} actualNumber={actualNumber} />
                        {:else}
                            <div class="last-number h-100">
                                {$i18n("Esperando número")}
                            </div>
                        {/if}
                        {#if numbers.length < numbersLimit}
                            <div style="display: flex; gap: 10px;justify-content: center;">
                                <!-- <div class="numbers-indicator">
                                    <GameNumbersIndicator {game} />
                                    <img class="icon" src="/images/bingo.svg" alt="">
                                </div> -->
                                <Button
                                    disabled={nextBtnDisabled}
                                    style="padding: 10px; min-width: 150px;"
                                    on:click={nextNumber}>
                                    <!-- <PlayIcon size={20} /> --><!--  -->
                                    <div class="numbers-indicator">
                                        <GameNumbersIndicator {game} />
                                        <img class="icon" src="/images/bingo.svg" alt="">
                                    </div>
                                    {#if isCooldown}
                                        <div class="cooldown" style="--cooldownTime: {cooldownTime}ms"></div>
                                    {/if}
                                </Button>
                            </div>
                        {:else}
                            <Alert color="light" class="text-center">
                                THE END
                            </Alert>
                        {/if}
                    </div>
                </Watch>
            {/if}
        </div>
    </div>
    <div class="numbers notranslate">
        {#if game}
            <svelte:component this={componentMap[GameTypeService.getNumbersGridComponentName(game.type)]} {game} />
        {/if}
    </div>
    <div class="right">
        <div class="game-clock">
            <GameClock />
            <If state={room.integratedDisplay}>
                <RightMenuBtn on:click={toggleRightMenu} />
            </If>
        </div>
        
        <article class="players notranslate">
            {#if !room.offline.value}
                <header>
                    Top {rankingSize} <img class="icon" src="/images/podium.svg" alt="">
                </header>
                <PlayersRanking roomId={room.id} maxPlayers={rankingSize} />
            {/if}
        </article>
        

        <If state={showQr}>
            <div class="room-link">
                <div class="game-code notranslate">
                    Pin {game?.code || ''}
                </div>
                <div class="qr-container">
                    <RoomQr roomId={room.id} gameId={game?.id} margin={1} />
                </div>
            </div>
        </If>

    </div>
    <div class="messages">
        <MessagesMarquee roomId={room.id} />
    </div>
    {#if reloading}
        <div class='banner bg-danger p-4 rounded w-75 d-flex gap-4 align-items-center'>
            <span style='font-size: 20px'><Icon name="exclamation-triangle-fill" /></span>
            <span>{$i18n("Parece que has perdido la conexión. Por favor, recarga la página")}</span>
        </div>
    {/if}
</div>

{#if figureNotice}
    <div class="full-screen" transition:fade>
        <div class="confetti">
            <Confetti />
        </div>
        <div class="content">
            <FigureName name={figureNotice.figureName} let:text={title}>
                <AwardTitle {title} />
            </FigureName>
            <PlayerDisplay player={figureNotice.player} {game} />
        </div>
    </div>
{/if}

{#if winner}
    <div class="full-screen" transition:fade>
        <div class="confetti">
            <Confetti />
        </div>
        <div class="content">
            <Win player={winner} {game} />
        </div>
    </div>
{/if}

<Menu isOpen={openRightMenu} toggle={toggleRightMenu} on:logout={onLogout}>
    
    <div class="d-flex gap-2 mb-3 notranslate">
        {#if winner}
            <Button on:click={clearGame}>
                {$i18n("Terminar")}
            </Button>
        {:else}
             <!-- toggleEndGameModal -->
             <div class='position-relative'>
                <Button on:click={toggleEndGameOptions}>
                    {$i18n("Terminar juego")}
                </Button>
                {#if showCancelOptions}
                    <div class='bg-white position-absolute d-flex flex-column rounded-3' style='z-index: 20;'>
                        <button on:click={() => endGame('training')} class='btn btn-light'>{$i18n("Formación")}</button>
                        <button on:click={() => endGame('game_change')} class='btn btn-light'>{$i18n("Cambiar juego")}</button>
                        <button on:click={() => endGame('network')} class='btn btn-light'>{$i18n("Internet")}</button>
                        <button on:click={() => endGame('game_test')} class='btn btn-light'>{$i18n("Pruebas")}</button>
                        <button on:click={toggleEndGameModal} class='btn btn-light'>{$i18n("Otros")}</button>
                    </div>
                {/if}
             </div>
            
        {/if}
    </div>

    <div class="mb-3 notranslate">
        <Button on:click={toggleRoomSettingsModal}>
            {$i18n("Ajustes de la sala")}
        </Button>
    </div>

    {#if room}
        <div class="mb-3 notranslate">
            <Button on:click={toggleQr}>
                {room.showRoomQrInMonitor.value ? $i18n("Ocultar QR") : $i18n("Mostrar QR")}
            </Button>
        </div>
    {/if}
    
</Menu>

<Modal isOpen={openEndGameModal}>
    <ModalHeader toggle={toggleEndGameModal}>
        {$i18n("Cancelación de juego")}
    </ModalHeader>
    <ModalBody> 
        <form>
            <FormGroup>
                <Label>{$i18n("¿Por qué quieres cancelar este juego?")}</Label>
                <input type="text" class="form-control" bind:value={cancelMotive}>
            </FormGroup>
            <!-- <Button type="submit" disabled={!cancelMotive}>{$i18n("Cancelar juego")}</Button> -->
            <button class='btn btn-warning' type="submit" disabled={!cancelMotive} on:click={() => endGame(cancelMotive)}>{$i18n("Cancelar juego")}</button>
        </form>
    </ModalBody>
</Modal>
<style lang="scss">
    .banner {
        position: absolute;
        top: 10px;
        left: 15%;
        z-index: 99999;
    }

    .monitor-view {
        overflow: hidden;
        display: grid;
        gap: 1rem;
        padding: 1rem;
        grid-template-columns: 1fr 2fr 1fr;
        grid-template-rows: auto 7rem;
        grid-template-areas:
            "historic numbers players"
            "messages messages messages";
        position: relative;
    }

    .game-logo {
        display: flex;
        justify-content: center;

        img {
            width: 17vw;
        }
    }

    .historic {
        grid-area: historic;
        display: flex;
        flex-direction: column;
        // padding-top: 2rem;
    }

    .game-historic {
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .numbers {
        grid-area: numbers;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .right {
        grid-area: players;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        position: relative;
        z-index: 2;
    }

    .players {
        flex: 1 1 0;
        overflow: hidden;
       
        header {
            font-family: ManagerTitle;
            font-size: 2rem;
            text-transform: uppercase;
            text-align: center;

            .icon {
                height: 0.9em;
                vertical-align: baseline;
            }
        }
    }
    
    .messages {
        grid-area: messages;
        position: relative;
        background-color: var(--color-secondary);
        margin: 0 -1rem;
    }

    .game-header {
        display: flex;
        justify-content: space-between;
        font-family: ManagerTitle;
        font-size: 1.6vw;
        text-transform: uppercase;
        margin-bottom: 0.3vw;
    }

    .game-clock {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
    }

    .game-code {
        background-color: var(--color-secondary);
        color: #000;
        padding: 0 0.75rem;
        margin-top: -0.8rem;
        margin-bottom: 0.75rem;
        border-radius: 5000px;
        box-sizing: border-box;
        height: 3.5vw;
        font-size: 2.5vw;
        line-height: 3.4vw;
    }

    .numbers-indicator {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.4em;
        color: black;
        font-family: ManagerTitle;
        text-align: center;

        .icon {
            height: 0.9em;
            color: black;
        }
    }

    .last-number {
        text-align: center;
        font-family: ManagerTitle;
        font-size: 4vw;
        text-transform: uppercase;
        display: flex;
        align-items: center;
    }

    .full-screen {
        position: fixed;
        z-index: 99;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.75);
        color: #fff;

        .content {
            position: relative;
            z-index: 2;
            width: 100%;
            max-width:600px;
        }
    }

    .room-link {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: -55px;
        background-color: #fff;
        border-radius: 20px;
        margin-left: 25px;
        margin-right: 25px;

        .qr-container {
            max-width: 70%;
            margin-bottom: 0.75rem;
        }
    }

    .confetti {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .cooldown {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.5);
        animation: cooldown var(--cooldownTime) linear;
    }

    @keyframes cooldown {
        from {
            width: 100%;
        }
        to {
            width: 0%;
        }
    }

</style>

